import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/shared/components/ui/dialog'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const DeleteProofDialog = ({
  open,
  proofName,
  onOpenChange,
  onConfirm,
}: {
  open: boolean
  proofName: string
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}) => {
  const { t } = useLocalization()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t('Remove proof from order', 'Ta bort korrektur från ordern')}
          </DialogTitle>

          <DialogDescription className="mt-2">
            {t(
              'Remove "{name}" from this order? The file is not deleted and can still be used on other orders or re-added here.',
              'Ta bort "{name}" från denna order? Filen raderas inte och kan fortfarande användas på andra ordrar eller läggas till här igen.'
            ).replaceAll('{name}', proofName)}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>
            {t('Cancel', 'Avbryt')}
          </Button>

          <Button variant="destructive" onClick={onConfirm}>
            {t('Remove from order', 'Ta bort från ordern')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
